import { IBonus } from '../../types/bonus';
import GeneralEnumService from '../../enumerables/general-enum';
import { getValFromEnum } from '../../components/redux-form/utils/dropdown-values';
import moment from 'moment';
import { numberWithCommas } from '../format';

export const groupDataToCsv = (data: IBonus[]): string[][] => {
    const groupData: string[][] = [['Provider', 'Referral', 'Note', 'Date', 'Amount $', 'Type', 'Status']];

    const GeneralEnumStatus = GeneralEnumService ? GeneralEnumService.getEnum('BonusStatus') : {};
    const statusItems: SelectObject[] = getValFromEnum(GeneralEnumStatus);

    const GeneralEnumType = GeneralEnumService ? GeneralEnumService.getEnum('BonusType') : {};
    const typeItems: SelectObject[] = getValFromEnum(GeneralEnumType);

    let sumAmount = 0;
    data.forEach((it) => {
        const createdAt = it.createdAt ? moment(it.createdAt).format('MMM D, YYYY') : '';
        const providerTitle: string = it?.provider?.fullName ? `${it.provider.fullName}` : '';
        const referralTitle: string = it?.referral?.fullName ? `${it.referral.fullName}` : '';
        const info: string = it?.info ? `${it.info}` : '';
        const amount: string = it?.amount ? `${it.amount}` : '0';

        sumAmount += +amount;
        let valuestatus: string | SelectObject | undefined = statusItems.find((its) => +its.value === +it.status);
        valuestatus = valuestatus ? `${valuestatus?.label}` : '';
        let valuetype: string | SelectObject | undefined = typeItems.find((its) => +its.value === +it.bonusType);
        valuetype = valuetype ? `${valuetype?.label}` : '';

        groupData.push([
            providerTitle,
            referralTitle,
            info,
            createdAt,
            `$${numberWithCommas(amount)}`,
            valuetype,
            valuestatus,
        ]);
    });
    groupData.push(['', '', '', '', `$${numberWithCommas(sumAmount)}`, '', '']);

    return groupData;
};
